import { render, staticRenderFns } from "./TodoListDetail.vue?vue&type=template&id=e0bf3686&scoped=true"
import script from "./TodoListDetail.vue?vue&type=script&lang=js"
export * from "./TodoListDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0bf3686",
  null
  
)

export default component.exports